import { Injectable } from '@angular/core';
import { CurrentOrganizationManagementService } from './current-organization-management.service';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';

@Injectable()
export class CurrentOrganizationManagementNoopService
  implements CurrentOrganizationManagementService
{
  readonly currentOrganizationId$ = new BehaviorSubject<string | null>(null);

  computeCurrentOrganization(): Observable<string | null> {
    return of(null);
  }
}
